import { useParams } from "react-router-dom";
import { useStudentDetailsQuery } from "../../../../../hooks/useStudentDetailsQuery";
import { Avatar, Box, Metadata, useTranslations, useUserProfilePicture, useFileUrl, ImagePreview } from "@bsm/component";
import { useMemo } from "react";
import { Users, User, IdCard, ImageIcon } from "lucide-react";

export const StudentSesignationCollectionIndividualContainer = () => {
    const { id } = useParams();
    const { data } = useStudentDetailsQuery(parseInt(id), true);

    const [NAME, RELATIONSHIP, ID_CARD] = useTranslations(i18nKeys);
    const assistants = useMemo(() => data?.parents?.filter((parent) => ['ASSISTANT'].includes(parent?.parentType)), [data]);
    const profilePictureUrl = useUserProfilePicture();
    const fileUrl = useFileUrl();

    return (
        <div className="overflow-hidden rounded-3xl shadow bg-white">
            {assistants?.map((assistant) => (
                <div key={assistant.user.id} className="p-8 flex flex-col gap-6">

                    <div className="flex flex-row items-start gap-0">

                        <div className="pr-8 flex items-center justify-center">
                            <ImagePreview
                                src={profilePictureUrl(assistant.user.id)}
                                alt={assistant.user?.fullName}
                                className="border border-gray-200 bg-blue-50 shadow-md w-40 h-40 rounded-full"
                            />
                        </div>

                        {/* Séparateur vertical */}
                        <div className="self-stretch w-px bg-[#EBECEF]" />

                        {/* Métadonnées */}
                        <div className="flex flex-col pl-8 flex-1 divide-y divide-[#EBECEF]">

                            {/* Nom complet */}
                            <div className="py-4 flex items-center gap-6">
                                <div className="p-3 rounded-xl !bg-[#dee2f5] text-[#5373E9] shadow-lg shadow-blue-500/30">
                                    <User size={20} />
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm text-gray-400">{NAME}</span>
                                    <span className="font-semibold text-gray-800">{assistant.user.fullName}</span>
                                </div>
                            </div>
                            {/* Titre en haut à gauche */}
                            <div className="py-4 flex items-center gap-6">
                                <div className="p-3 rounded-xl !bg-[#dee2f5] text-[#5373E9] shadow-lg shadow-blue-500/30">
                                    <Users size={20} />
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm text-gray-400">{RELATIONSHIP}</span>
                                    <span className="font-semibold text-gray-800">{assistant.relationship}</span>
                                </div>
                            </div>

                            {/* Carte d'identité */}
                            <div className="py-4 flex items-start gap-6">
                                <div className="p-3 rounded-xl !bg-[#dee2f5] text-[#5373E9] shadow-lg shadow-blue-500/30">
                                    <IdCard size={20} />
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm text-gray-400">{ID_CARD}</span>
                                    {assistant.user.idCard && (
                                        <ImagePreview
                                            src={typeof assistant.user.idCard === 'string' ? fileUrl(assistant.user.idCard) : fileUrl(assistant.user.idCard.id)}
                                            alt={ID_CARD}
                                            className="w-50 h-20 object-cover rounded-xl mt-3"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const i18nKeys = [
    "DesignationCollectionIndividual.name",
    "DesignationCollectionIndividual.relationship",
    "DesignationCollectionIndividual.idCard"
];